<template>
  <div class="content">
    <img style="width: 100%;height: auto;display: block;margin-bottom: 1.33333vw;" :src="require('../../assets/'+appTheme+'/fast_code_ad.jpg')" alt="" />
    <van-form @submit="onSubmit">
      <van-field name="radio" label="类型">
        <template #input>
          <van-radio-group v-model="checked" direction="horizontal">
            <van-radio name="1">个人</van-radio>
            <van-radio name="2">企业</van-radio>
          </van-radio-group>
        </template>
      </van-field>
      <div>
        <van-field v-if="checked==1"
                   v-model="id_name"
                   name="真实姓名"
                   label="真实姓名"
                   placeholder="请输入您的真实姓名"
                   :rules="[{ required: true, message: '' }]"
        />
        <van-field v-if="checked==1"
          v-model="id_number"
          name="身份证号码"
          label="身份证号码"
          placeholder="请输入身份证号码"
          :rules="[{ required: true, message: '' }]"
        />
        <van-field v-if="checked==1"
          name="联系人手机号"
          label="联系人手机号"
          v-model="tel"
          type="tel"
          placeholder="请输入联系人手机号"
          :rules="[{ required: true, message: '' }]"
        />
        <van-field v-if="checked==1"
                   v-model="user_add"
                   name="使用场景详细地址"
                   label="使用场景详细地址"
                   placeholder="请输入使用场景详细地址"
                   :rules="[{ required: true, message: '' }]"
        />
        <van-field v-if="checked==1"
                   name="个人银行卡账户"
                   label="个人银行卡账户"
                   v-model="user_bank_number"
                   type="tel"
                   placeholder="请输入个人银行卡账户"
                   :rules="[{ required: true, message: '' }]"
        />

        <van-field v-if="checked==1"
                   v-model="user_bank_name"
                   name="银行卡支行"
                   label="银行卡支行"
                   placeholder="请输入银行卡支行"
                   :rules="[{ required: true, message: '' }]"
        />
        <van-field v-if="checked==2"
                   v-model="company_name"
                   name="公司/商户名称"
                   label="公司/商户名称"
                   placeholder="请输入公司/商户名称"
                   :rules="[{ required: true, message: '' }]"
        />
        <van-field v-if="checked==2"
                   v-model="id_name_coy"
                   name="法人名字"
                   label="法人名字"
                   placeholder="请输入法人名字"
                   :rules="[{ required: true, message: '' }]"
        />
        <van-field v-if="checked==2"
                      v-model="id_number_coy"
                      name="法人身份证号码"
                      label="法人身份证号码"
                      placeholder="请输入法人身份证号码"
                      :rules="[{ required: true, message: '' }]"
      />

        <van-field v-if="checked==2"
                   name="联系电话"
                   label="联系电话"
                   v-model="tel_coy"
                   type="tel"
                   placeholder="请输入联系电话"
                   :rules="[{ required: true, message: '' }]"
        />
        <van-field
          v-model="id_add" v-if="checked==2"
          name="地址"
          label="地址"
          placeholder="请输入您的地址"
          :rules="[{ required: true, message: '' }]"
        />
        <van-field v-if="checked==2"
                   v-model="id_number_bank_coy"
                   name="对公账户号码"
                   label="对公账户号码"
                   placeholder="请输入对公账户号码"
                   :rules="[{ required: true, message: '' }]"
        />
        <van-field v-if="checked==2"
                   v-model="id_name_bank_coy"
                   name="对公账户银行支行"
                   label="对公账户银行支行"
                   placeholder="请输入对公账户银行支行"
                   :rules="[{ required: true, message: '' }]"
        />

        <div class="brand-box left-justifying" style="align-items: self-start;">
          <div class="title-name">
             {{checked==1?'个人银行卡照片':'公账户银行卡照片'}}
          </div>
          <div>
            <div class="left-justifying" style="align-items: self-start;">
              <van-uploader :preview-options="previewImage" :max-size="12000 * 1024" @oversize="onOversize" :after-read="afterBankPic" :before-read="beforeRead" :max-count="1" v-model="fileBankPic" />
              <van-uploader :preview-options="previewImage" :max-size="12000 * 1024" @oversize="onOversize" :after-read="afterBankPicSec" :before-read="beforeRead" :max-count="1" v-model="fileBankPicSec" />

            </div>
          </div>
        </div>
        <div class="hint-license-box">
          <div class="hint-license" style="padding-left: 29.6vw;color: #727272;background: #fff;padding-bottom: 1.33333vw;">{{checked==1?'请上传银行卡正反面':'请上传对公账户银行卡正反面照片'}}  </div>
        </div>
        <div class="brand-box left-justifying" style="align-items: self-start;" v-if="checked==2">
          <div class="title-name">
            营业执照
          </div>
          <div>
            <div class="left-justifying" style="align-items: self-start;">
              <van-uploader :preview-options="previewImage" :max-size="12000 * 1024" @oversize="onOversize" :after-read="afterIdPicBusiness" :before-read="beforeRead" :max-count="1" v-model="fileBusinessLicense" />
            </div>
          </div>
        </div>
        <div class="brand-box left-justifying" style="align-items: self-start;">
          <div class="title-name">
            身份证照片
          </div>
          <div>
            <div class="left-justifying" style="align-items: self-start;">
              <van-uploader :preview-options="previewImage" :max-size="12000 * 1024" @oversize="onOversize" :after-read="afterIdPic" :before-read="beforeRead" :max-count="1" v-model="fileListIdPic" />
              <van-uploader :preview-options="previewImage" :max-size="12000 * 1024" @oversize="onOversize" :after-read="afterIdPicSec" :before-read="beforeRead" :max-count="1" v-model="fileListIdPicSec" />

            </div>
          </div>
        </div>
        <div class="hint-license-box">
          <div class="hint-license" style="padding-left: 29.6vw;color: #727272;background: #fff;padding-bottom: 1.33333vw;"> {{checked==1?'请上传您的身份证正反面照片':'请上传法人身份证正反面照片'}} </div>
        </div>
        <div class="brand-box left-justifying" style="align-items: self-start;" v-if="checked==2">
          <div class="title-name">
            门面照片
          </div>
          <div>
            <div class="left-justifying" style="align-items: self-start;">
              <van-uploader :preview-options="previewImage" :max-size="12000 * 1024" @oversize="onOversize" :after-read="afterIdPicShop" :before-read="beforeRead" :max-count="1" v-model="fileShopPic" />
            </div>
          </div>
        </div>
        <div class="hint-license-box" v-if="checked==2">
          <div class="hint-license" style="padding-left: 29.6vw;color: #727272;background: #fff;padding-bottom: 1.33333vw;"> 请上传门面照片（手持营业执照） </div>
        </div>
<!--        <van-field disabled-->
<!--          v-model="serveName"-->
<!--          name="客服经理"-->
<!--          label="客服经理"-->
<!--        />-->
        <div class="serve-name">客服经理：{{serveName}}</div>
      </div>
      <div class="hint-card" style="margin: 2.66667vw;font-size: 3.2vw;color: #58BB3B;">填写真实的个人信息，将上报银联中心核实审核</div>
      <div style="margin: 2.13333vw;padding: 5.33333vw 0 0">
        <van-button round block type="info" native-type="submit" style="background: #FDD80D;border-color: #FDD80D;color: #282828">提交</van-button>
      </div>

    </van-form>
    <!--    分享弹框-->
    <van-overlay :show="shareShow">
      <div class="wrapper" @click.stop>
        <div class="icon-box" @click="shareShowHide"><van-icon size="24" color="#fff" name="cross" /></div>
        <img v-if="posterUrl" class="poster-url" crossorigin="anonymous" :src="posterUrl" alt="" />
        <div class="imageWrapper" v-else id="imageWrapper" ref="imageTofile">
          <img class="img-goods goodsImg" :src="logoImg" alt="" />
          <div class="title">全球灯云快码申请</div>
          <img ref="qrcode" class="qr-code-img" :src="qrcodeUrl" alt="" />
          <div class="hint">长按二维码保存图片</div>
        </div>
      </div>
    </van-overlay>
    <!-- 分享弹框end -->
    <div class="hidden" style="display: none;">
      <!--    width: 69.33333vw; height: 118.66667vw;-->
      <vue-canvas-poster v-if="qrcodeUrl" :widthPixels="1000" :painting="painting" @success="success" @fail="fail"></vue-canvas-poster>
    </div>
  </div>
</template>

<script>
import {registerCode} from '@/api/wallet'
import upLoaderImg from "../../api/upLoaderImg";
import { VueCanvasPoster } from 'vue-canvas-poster'
import QRCode from "qrcode";
export default {
  name: "fastCode",
  data(){
    return{
      appTheme:this.$store.state.appTheme,
      shareShow:false,
      checked: '1', // 个人 2企业
      id_number:'',
      tel:'',
      id_name:'',
      user_add: '', // 个人地址
      user_bank_number: '', // 个人银行卡账户
      user_bank_name:'', // 银行卡支行
      previewImage:{
        closeable: true,
      },
      id_img_front: '',
      id_img_reverse:'',
      fileListIdPic:[],
      fileListIdPicSec:[],
      fileBusinessLicense:[],
      busines_slicense_img:'',
      id_add:'',
      tel_coy:'',
      id_name_coy: '',// 法人
      company_name:'',
      id_number_coy: '',// 法人身份证
      id_number_bank_coy: '',// 对公账户号码
      id_name_bank_coy: '', // 账号支行
      fileBankPic: [],
      fileBankPicSec:[],
      bank_img_front: '', // 银行卡正面
      bank_img_reverse: '',
      fileShopPic: [],
      shop_img: '', // 门面照片
      serveName: '林小姐(18688111127)',
      customer_service_phone: '18688111127',
      customer_service_full_name:'林小姐',
      userId: '',
      posterShow: 0, // 1显示海报 0 不显示
      qrcodeUrl: '', // 二维码
      shareItem: '',
      posterUrl:'', // 海报
      shareGoodsImg: '',
      painting:{
        width: '520px',
        height: '890px',
        background: '#ffffff',
        borderRadius: '10px'
      },
      pic: '',
      logoImg:''
    }
  },
  components: {
    VueCanvasPoster
  },
  created() {
    let http = window.location.protocol+'//'
    let url = window.location.hostname // 获取当前访问（域名）
    this.logoImg = http+url+'/logo_poster.png' //'https://jpzs-zst.itos.cn/logo.jpg'
    // console.log('logoImg',this.logoImg)
    console.log(this.$route.query)
    if (this.$route.query.serveName){
      this.customer_service_phone = this.$route.query.serveTel
      this.customer_service_full_name = this.$route.query.serveName
      this.serveName =  this.customer_service_full_name+'('+this.customer_service_phone+')'
      this.userId = this.$route.query.userId
      // console.log(this.$route.query.posterShow)
      if (this.$route.query.posterShow != undefined){
        this.posterShow = this.$route.query.posterShow
        // console.log('显示',this.posterShow)
        this.shareClick()
      } else {
        // console.log('不显示')
        this.posterShow = 0
      }
    } else {
      this.customer_service_phone = '18688111127'
      this.customer_service_full_name = '林小姐'

    }
  },
  methods:{
    shareClick(){ // 生成二维码
      var id = this.userId
      let baseUrl = ''
      let http = window.location.protocol+'//'
      let url = window.location.hostname // 获取当前访问（域名）
      baseUrl = http+url+`/polyCode?serveName=${this.customer_service_full_name}&serveTel=${this.customer_service_phone}&userId=${id}`  //'https://jpzs-zst.itos.cn/goodDetails?id=750'
      // console.log(baseUrl)
      let qrcodeUrl = baseUrl
      QRCode.toDataURL(qrcodeUrl, (err, qr) => {
        if (err) {
          this.$toast('生成二维码失败');
        } else {
          this.qrcodeUrl = qr;
          // console.log(this.qrcodeUrl)
          this.shareShow = true
          this.drawPoster()
        }
      });

    },
    drawPoster(){
      this.painting = {
        width: '520px',
        height: '670px',
        background: '#ffffff',
        borderRadius: '10px',
        views: [
          {
            type: 'rect',
            css: {
              width: '502px',
              height: '652px',
              right: '9px',
              bottom: '9px',
              borderRadius: '10px',
              borderWidth: '8px',
              color: '#ffffff',
              borderColor: '#FDD80D',
            }
          },
          {
            type: 'image',
            url: this.logoImg,// this.shareGoodsImg, // 'https://www.sunniejs.cn/static/avatar.png'
            css: {
              width: '300px',
              height: '185px',
              top: '25px',
              left: '95px',
            }
          },
          {
            type: 'text',
            text: '全球灯云快码申请',
            css: [
              {
                top: '210px',
                width: '400px',
                maxLines: 2,
                lineHeight: '50px',
                left: '60px',
                fontSize: '32px',
                textAlign:'center'
              }
            ]
          },
          {
            type: 'text',
            text: '客服经理：'+this.serveName,
            css: [
              {
                top: '262px',
                width: '400px',
                maxLines: 2,
                lineHeight: '50px',
                left: '60px',
                fontSize: '26px',
                textAlign:'center'
              }
            ]
          },
          {
            type: 'image',
            url: this.qrcodeUrl,
            css: {
              width: '270px',
              height: '270px',
              top: '306px',
              left: '125px'
            }
          },
          {
            type: "text",
            text: "长按二维码保存图片",
            css: {
              top: "570px",
              left: "140px",
              width: "360px",
              maxLines: 1,
              fontSize: "26px",
              color: '#E43A0D'
            }
          }
        ]
      }
    },
    //成功生成海报
    success(src) {
      this.posterUrl = src;
      // console.log(src)
    },
    fail(err) {
      // alert(err)
      console.log('fail', err)
    },
    shareShowHide(){
      this.shareShow = false
      // console.log(this.qrcodeUrl)
    },
    onOversize(file) {
      console.log(file);
      this.$toast('文件大小不能超过 5000kb');
    },
    beforeRead (file) {	//上传之前校验
      if (file.type !== 'image/jpeg' && file.type !== 'image/png') {
        this.$toast('只允许上传jpg/png格式的图片！')
        return false
      }
      return true
    },
    async afterIdPic(file){ // 身份证正面
      var data = {
        file: file.file
      }
      var res = await upLoaderImg(data) // 上传图片调用接口
      if (res.code==200){
        this.id_img_front = res.data.source_url
      } else {
        this.$toast(message)
      }

    },
    async afterIdPicSec(file){ // 身份证反面
      var data = {
        file: file.file
      }
      var res = await upLoaderImg(data) // 上传图片调用接口
      if (res.code==200){
        this.id_img_reverse = res.data.source_url
      } else {
        this.$toast(message)
      }
    },
    async afterBankPic(file){ // 上传正面
      var data = {
        file: file.file
      }
      var res = await upLoaderImg(data) // 上传图片调用接口
      if (res.code==200){
        this.bank_img_front = res.data.source_url
      } else {
        this.$toast(message)
      }
    },
    async afterBankPicSec(file){ // 上传反面
      var data = {
        file: file.file
      }
      var res = await upLoaderImg(data) // 上传图片调用接口
      if (res.code==200){
        this.bank_img_reverse = res.data.source_url
      } else {
        this.$toast(message)
      }
    },
    async afterIdPicBusiness(file){ // 营业执照
      var data = {
        file: file.file
      }
      var res = await upLoaderImg(data) // 上传图片调用接口
      if (res.code==200){
        this.busines_slicense_img = res.data.source_url
      } else {
        this.$toast(message)
      }
    },
    async afterIdPicShop(file){ // 门面照片
      var data = {
        file: file.file
      }
      var res = await upLoaderImg(data) // 上传图片调用接口
      if (res.code==200){
        this.shop_img = res.data.source_url
      } else {
        this.$toast(message)
      }
    },
    onSubmit(){
      let data = ''
      if (this.checked=='1'){ //个人
        data = {
          full_name: this.id_name,
          phone:this.tel,
          identity_card_facade_image: this.id_img_front,
          identity_card_back_image:this.id_img_reverse,
          type: 'personal',
          identity_card_number:this.id_number,
          address:this.user_add,
          bank_card_number:this.user_bank_number,
          bank_card_facade_image:this.bank_img_front,
          bank_card_back_image:this.bank_img_reverse,
          customer_service_full_name:this.customer_service_full_name,
          customer_service_phone:this.customer_service_phone,
          bank_branch_name:this.user_bank_name,
          user_id:this.userId !=''? this.userId: null
        }

      } else { // 企业
        data = {
          full_name: this.id_name_coy,
          phone:this.tel_coy,
          identity_card_facade_image: this.id_img_front,
          identity_card_back_image:this.id_img_reverse,
          identity_card_number:this.id_number_coy,
          business_license_image: this.busines_slicense_img,
          type: 'company',
          company_name:this.company_name,
          address:this.id_add,
          bank_card_number:this.id_number_bank_coy,
          bank_card_facade_image:this.bank_img_front,
          bank_card_back_image:this.bank_img_reverse,
          customer_service_full_name:this.customer_service_full_name,
          customer_service_phone:this.customer_service_phone,
          address_facade_image:this.shop_img,
          bank_branch_name:this.id_name_bank_coy,
          user_id:this.userId !=''? this.userId:null
        }
      }
      if (this.id_img_front == ''||this.id_img_reverse==''){
        this.$toast('请上传传身份证照片')
        return false
      } else if (this.bank_img_front == ''||this.bank_img_front==''){
        this.$toast('请上传银行卡照片')
        return false
      } else {
        if (this.checked=='2' && this.busines_slicense_img==''){
          this.$toast('请上传营业执照照片')
          return false
        }
        registerCode(data).then(res=>{
          if (res.code==200){
            this.$dialog.alert({
              title: '标题',
              message: res.message,
            }).then(() => {
              // on close
              this.$router.push('/user');
            });
          }else {
            this.$toast(res.message)
          }
        })
      }

    }
  }
}
</script>

<style lang="scss" scoped>
.wrapper{
  .icon-box{
    width: 630px;text-align: right;margin: 160px auto 30px;
  }
  img{
    width: 520px;display: block;height: auto;margin: 0 auto;
  }
  .imageWrapper{
    width: 530px;background: #FFFFFF;margin: 0 auto;text-align: center;padding-bottom: 60px;padding-top: 20px;
    .img-goods{
      width: 200px;height: auto;
      display: block;margin: 0 auto 30px;border: 2px solid #F5F5F5;
    }
    .qr-code-img{
      width: 300px;height: 300px;display: block;margin: 50px auto 20px;
    }
  }
}
.content{
  padding-bottom: 80px;
}
.brand-box{
  padding: 20px 30px 10px;background: #ffffff;position: relative;text-align: left;
  .title-name{
    width: 195px;text-align: left;
    color: #282828;
  }
}
.hint-box{
  padding: 30px 30px 0;font-size: 26px;color: #282828;text-align: left;line-height: 60px;
}
/deep/.van-cell--required::before{
  color: #fff;
}
.serve-name{
  background: #fff;padding-left: 25px;padding-top: 40px;padding-bottom:30px;
  font-weight: bold;
}

</style>
